import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "collapse",
  "use": "collapse-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"collapse\">\n    <path fill-rule=\"evenodd\" d=\"m18.998 15.306-.786.626-5.721-5.582-5.714 5.562-.784-.688L12.435 9.5l.124-.379.119.379 6.32 5.806z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol